export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";